import { createContext } from "react";
import { IFilterData } from "gateways/oficinas.interfaces";

export const FilterDataContext = createContext<IFilterData>({ });